import { client } from '$lib/api/Client';

export const load = async ({ params, parent }) => {
  const { queryClient } = await parent();
  await queryClient.prefetchQuery({
    queryKey: ['profile', params.username],
    queryFn: () => client.users.retrieveProfile({ username: params.username }),
  });

  // await queryClient.prefetchQuery({
  //   queryKey: ['profileCompletion', params.username],
  //   queryFn: () => client.users.retrieveProfileCompletion({ username: params.username }),
  // });
};
